var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseCard',{attrs:{"title":"Total Price","edit":false}},[_c('v-container',[(_vm.isLoading)?_c('div',[_c('v-progress-linear',{attrs:{"indeterminate":""}})],1):_c('div',[_vm._v(" "+_vm._s("$" + _vm.totalPrice.toFixed(2))+" ")]),_c('br'),_c('small',[_vm._v("Total price does not include shipping charges.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }